import { ModalFullscreen, Spinner } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ChatModal.css';
import { TRecommendation } from '../../types/recommendation';

export interface IChatModalProps {
  isOpen: boolean;
  offer?: TRecommendation;
  gaLabel?: string;
  defaultMessage?: string;
  onOpen?(): void;
  onClose(): void;
}

export function ChatModal({ isOpen, offer, onClose, onOpen, gaLabel, defaultMessage }: IChatModalProps) {
  const [isLoading, setIsLoading] = React.useState(true);

  const onLoad = () => setIsLoading(false);

  React.useEffect(() => {
    if (isOpen && onOpen) {
      onOpen();
    }
  }, [isOpen, onOpen]);

  if (!offer) {
    return null;
  }

  const { offerId, dealType, offerType } = offer;

  /* istanbul ignore next */
  const src =
    `/dialogs/?hostType=frame&offerId=${offerId}` +
    `&dealType=${dealType}&offerType=${offerType}` +
    `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
    `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
    '&pageType=Recommendations';

  return (
    <ModalFullscreen onClose={onClose} open={isOpen}>
      <div className={styles['iframe-container']}>
        <span className={styles['close']}>
          <IconActionClose16 color="icon-primary-default" onClick={onClose} />
        </span>
        {isLoading && (
          <span className={styles['spinner']} data-testid="spinner">
            <Spinner size={16} />
          </span>
        )}
        <iframe data-name="ChatModal" className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
      </div>
    </ModalFullscreen>
  );
}
